// Real Dream Couture bridal and evening wear photos displayed on the website
const BASE = "https://base44.app/api/apps/6a45716f29f4beead6ccd3d2/files/mp/public/6a45716f29f4beead6ccd3d2/";

// Dream Couture Bridal Collection photos (from bridalCollectionImages.js + bridal collection page)
const BRIDAL_IMAGES = [
  { url: `${BASE}c9ccc9e0e_aria.jpg`, label: "Aria", collection: "Bridal" },
  { url: `${BASE}63d2e60bc_joy.jpg`, label: "Joy", collection: "Bridal" },
  { url: `${BASE}562db8ca1_lauren.jpg`, label: "Lauren", collection: "Bridal" },
  { url: `${BASE}503618efa_laurel.jpg`, label: "Laurel", collection: "Bridal" },
  { url: `${BASE}1c3ad9384_beatrice.jpg`, label: "Beatrice", collection: "Bridal" },
  { url: `${BASE}cda2ac9ba_lala.jpg`, label: "Lala", collection: "Bridal" },
  { url: `${BASE}ad48d7bb5_ashley.jpg`, label: "Ashley", collection: "Bridal" },
  { url: `${BASE}dc8939f53_savanah.jpg`, label: "Savanah", collection: "Bridal" },
  { url: `${BASE}8b4fa4496_taylor.jpg`, label: "Taylor", collection: "Bridal" },
  { url: `${BASE}1b39d5b56_shawn.jpg`, label: "Shawn", collection: "Bridal" },
  { url: `${BASE}7c4bb1ff9_leona.jpg`, label: "Leona", collection: "Bridal" },
  { url: `${BASE}d7f1e66c2_pearl.jpg`, label: "Pearl", collection: "Bridal" },
  { url: `${BASE}d56093195_emma.jpg`, label: "Emma", collection: "Bridal" },
  { url: `${BASE}33b70bd67_hailey.jpg`, label: "Hailey", collection: "Bridal" },
  { url: `${BASE}48ec0dc5e_bridal_lauretta.png`, label: "The Lauretta", collection: "Bridal" },
];

// Dream Couture Evening Wear photos (from EveningWearPage.jsx)
const EVENING_GOWNS = [
  { name: "Coral Whisper", image: "9d434f5c1_evening_01.jpeg", image2: "91779fd2b_evening_02.jpeg" },
  { name: "Emerald Sovereign", image: "7b93d63d5_evening_04.jpeg", image2: "0ecc91860_evening_03.jpeg" },
  { name: "Noir Allure", image: "7b9c4f461_evening_06.jpeg", image2: "85c3dce66_evening_05.jpeg" },
  { name: "Emerald Mermaid", image: "eb2ce733d_evening_08.jpeg", image2: "01a32fc44_evening_07.jpeg" },
  { name: "Noir Grande", image: "db66a66ec_evening_10.jpeg", image2: "d6fcc2b9f_evening_09.jpeg" },
  { name: "Noir Siren", image: "254a0f13c_evening_11.jpeg", image2: "53e68b73a_evening_12.jpeg" },
  { name: "Noir Halo", image: "31b76def5_evening_13.jpeg", image2: "690e42301_evening_14.jpeg" },
  { name: "Rose Couture", image: "9a4b839d1_evening_15.jpeg", image2: "a6c385220_evening_16.jpeg" },
  { name: "Midnight Blue", image: "2a2366d0f_evening_17.jpeg", image2: "991725433_evening_18.jpeg" },
  { name: "Noir Diva", image: "20b974442_evening_19.jpeg", image2: "b2d075b95_evening_20.jpeg" },
  { name: "Rose Ballerine", image: "0e382d1f6_evening_21.jpeg", image2: null },
];

const EVENING_IMAGES = EVENING_GOWNS.flatMap(g => {
  const imgs = [{ url: BASE + g.image, label: g.name, collection: "Evening" }];
  if (g.image2) imgs.push({ url: BASE + g.image2, label: `${g.name} (back)`, collection: "Evening" });
  return imgs;
});

export const DREAM_COUTURE_IMAGES = [...BRIDAL_IMAGES, ...EVENING_IMAGES];